const linerGradients = {
   resourceItemGradient: 'linear-gradient(to bottom, #00aaff 1%, #004aa6)',
   resourceItemBGGradient:
      'linear-gradient(to bottom,rgba(255, 255, 255, 1) 0%,rgba(130, 148, 200, 1) 100%,rgba(0, 44, 170, 0.88) 100%)',
   resourceCountGradient: 'linear-gradient(to bottom, #00aaff, #004aa6)',
   superRunsCompletionGradient: 'linear-gradient(to bottom, #ffc800, #b34100)',
   matchconfigItemGradient:
      'linear-gradient(to bottom, #ffffff 0%, #8294c8 100%, rgba(0, 44, 170, 0.88) 100%)',
   matchConfigIconBgGradient:
      'linear-gradient(148deg, #5d6a94 -26%, rgba(93, 106, 148, 0) 84%)',
   gameModePropertyGradient: 'linear-gradient(to bottom, #00aaff 1%, #004aa6)',
   gameMode: {
      novoiceGradient:
         'linear-gradient(to bottom, #b99bff 2%, #9066f1 11%, #814bff 50%)',
      amatureGradient:
         'linear-gradient(to bottom, #ffa1e2 1%, #f645c5 12%, #be2c85 50%)',
      semiProGradient:
         'linear-gradient(to bottom, #3affc3 2%, #2ae2d8 15%, #2e70ff 60%)',
      proGradient:
         'linear-gradient(to bottom, #ffdcaa 5%, #fb7d24 25%, #d34475 49%)',
      worldClassGradient:
         'linear-gradient(to top, rgba(33, 71, 255, 0.54), rgba(112, 135, 255, 0) 80%, rgba(73, 170, 255, 0.39) 40%, #31deff59 20%)',
      worldClassBaseGradient:
         'linear-gradient(to bottom, #d0ff46 2%, #0bc99f 12%, #06848d 19%, #6a4cac 81%, #3198ff)',
      ultimateGradient:
         'linear-gradient(to top, rgba(154, 58, 150, 0.54), rgba(112, 135, 255, 0) 80%, rgba(73, 170, 255, 0.39) 40%, #c531ff4d 20%)',
      ultimateGradientBase:
         'linear-gradient(to bottom, #ffd846 2%, #eb247a 25%, #003db5 81%, #0ad2c2)',
      rectangularGradient:
         'linear-gradient(300deg, rgba(255, 255, 255, 0.1) 47%, rgba(255, 255, 255, 0) 47%)'
   },
   profileLineBarGradient:
      'linear-gradient(to right, #0852b2 0%, #f47400 100%)',
   headerScoreGradient:
      'linear-gradient(to right, #0852b2 3%, rgba(8, 82, 178, 0.3))',
   tournamentKnockoutMatchPlayerCardGradient:
      'linear-gradient(to bottom, #4400cc 0%, #24006b 100%);',
   tournamentPlayingContainerGradient:
      'linear-gradient(to bottom, #ff9e5e, #fa6400);',
   youWonIbcRatingPointsBottomLinearGradient:
      'linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, #8294c8 100%, rgba(0, 44, 170, 0.88) 100%)',
   winnerCardBorderGradient: 'linear-gradient(to bottom, #ffa519, #f7b500)',
   leaderBoardNextRoundGradient:
      'linear-gradient(to bottom, #00c6ff, #0072ff), linear-gradient(to bottom, #002967, #002967);',
   signInTextBorderGradient:
      'linear-gradient(126deg, #006fe3 36%, #ff6b00 45%);',
   quickStartGradient1:
      'linear-gradient(to bottom, #1f2430, rgba(31, 36, 48, 0.2))',
   packageCardBorderGradient:
      'linear-gradient(180deg, #1f2430 0%, rgba(255, 145, 0, 0.5) 100%)',
   createTournamentGradient: 'linear-gradient(to right, #ff512f, #f09819)',
   questTextGradient: 'linear-gradient(to right, #f09819 0%, #edde5d)',
   gameKeyNewTagGradient: 'linear-gradient(to right, #ff512f, #f09819)',
   blackGradient: 'linear-gradient(to bottom,#212329 0%,black 100%)',
   singleLeaguePoolTableGradient:
      'linear-gradient(180deg, #4400CC 0.28%, #24006B 99.86%), rgba(0, 0, 0, 0.6)',
   joinTournamentTitleGradient:
      'linear-gradient(180deg,rgba(255, 255, 255, 0.1) 61.44%,rgba(0, 0, 0, 0.1) 61.44%),#fff;',
   knockOutCardVersusTextGradient:
      'linear-gradient(180deg, #fad961 0%, #f76b1c 100%)',
   knockOutCardSelfUserBorderGradient:
      'linear-gradient(88.61deg, #FA6400 3.16%, #FF9650 99.59%)',
   knockOutCardOtherUserBorderGradient:
      'linear-gradient(86.39deg, #44D7B6 6.82%, #00BDFF 101.21%)',
   knockOutWonTextBgGradient:
      'linear-gradient(180deg, #3b961d 0%, #429321 100%)',
   coOpTeamOneBorder: 'linear-gradient(135deg, #fcb132 0%, #ef6128 100%)',
   coOpTeamTwoBorder: 'linear-gradient(180deg, #3dd5ff 0%, #00bcd4 100%)',
   versusText:
      'linear-gradient(180deg,rgba(255, 255, 255, 0.2) 61.44%,rgba(0, 0, 0, 0.2) 61.44%)'
}

const colors = {
   abbey: '#4f5259',
   allScreenBg: '#131418',
   azulTwo: '#1665d8',
   battleshipGrey: ' #848482',
   battleShipGrey: '#6c7285',
   battleshipGreyTwo: '#717276',
   battleShipGrey80: 'rgba(255, 255, 255, 0.8)',
   pureBlack: '#000000',
   black: '#252421',
   blackFour: '#080808',
   blackSix: '#1e1e1e',
   black10: 'rgba(0,0,0,0.1)',
   black12: 'rgba(0, 0, 0, 0.12)',
   black2: '#252421',
   black32: 'rgba(0, 0, 0, 0.32)',
   black50: 'rgba(0, 0, 0, 0.5)',
   black80: 'rgba(0, 0, 0, 0.8)',
   blackCoral: '#5C5F6F',
   vampireBlack: '#0A0B0F',
   almostBlack: '#0c0e13',
   blackPearl: '#000a18',
   blackBg: '#252421',
   blackRussian: '#191a1f',
   blackRussianTwo: '#18191e',
   blackRussianThree: '#1a1b20',
   blackSeven: '#101010',
   blackTwo: '#262626',
   blackTwo85: 'rgba(0, 0, 0, 0.85)',
   black70: 'rgba(0, 0, 0, 0.7)',
   blackThree: '#121212',
   blackJet: '#343437',
   blueTwo: '#0043FF',
   fluorescentBlue: '#15E2FF',
   electricBlue: '#85F3FF',
   blue: '#1f2c8c',
   blue200: '#BFDBFE',
   blue300: '#93C5FD',
   blue400: '#60A5FA',
   blue900: '#1E3A8A',
   blueBlue: '#1d4ed8',
   blueGreyTwo: '#7b8fac',
   blueGreyThree: '#1c202c',
   bluePurple: '#3800ff',
   blueShade: '#4d5db7',
   blueButton: '#0852b2',
   blueyGrey: '#8892a4',
   blueBerry: '#509DF8',
   spanishBlue: '#016DB9',
   bluishBlack: '#151e2a',
   blush: '#f4c4a1',
   brown: '#733900',
   brown70: 'rgba(109, 54, 0, 0.7)',
   brightGrey: '#595b61',
   brightGreyTwo: '#4f5056',
   charcoalGrey: '#2a2c34',
   charcoalGreyTwo: '#303238',
   charcoalGreyFour: '#2a2b34',
   charcoalGreyFive: '#2a2c35',
   coolGrey: '#a3a7b3',
   cricketPitchBg: '#cec682',
   carmine: '#001a96',
   cobalt: '#01519B',
   dark: '#131418',
   darkTen: '#1b1c22',
   darkThirteen: '#0e0e11',
   darkBlue80: 'rgba(1,7,79,0.8)',
   darkBlueGray: '#1c2342',
   darkBlueGrayTwo: '#131937',
   darkBlueGrayThree: '#1c2020',
   darkBlueGrey: '#1c2342',
   darkBlueGreyTwoProfile: '#131937',
   darkGrey: '#aaaaaa',
   darkGreyBlueTwoSix: 'rgba(53, 78, 110, 0.6)',
   darkIndigo: '#070b24',
   darkIndigoTwo: '#080d26',
   darkIndigoThree: '#050b18',
   darkIndigoFive: '#0d1f4d',
   darkMaroon: '#46040a',
   darkSideBar: '#131418',
   darkSkyBlue: '#3bb6e7',
   darkPurlple: '#3404a4',
   darkOrange: '#fa6400',
   darkRum: '#2d3744',
   darkThree: '#292d37',
   darkTwo: `#212329`,
   darkFour: '#18191f',
   darkSix: '#1e293b',
   darkEight: '#20212b',
   darkNavy: '#000c2f',
   darkGreyTwo: '#212126',
   darkCharcoal: '#303036',
   midnightExpress: '#262B3B',
   ateneoBlue: '#0B4C66',
   dodgerBlueOne: '#0072ff',
   dodgerBlueTwo: '#008dff',
   blue500: '#3b82f6',
   deepSkyBlue: '#217df1',
   dodgerBlueThree: '#0084ff',
   dusk: '#4c637d',
   darkPumpkinOrange: '#ffa519',
   smashedPumpkin: '#FF6F3F ',
   darkTangerine: '#FF9C15',
   mangoTango: 'rgba(244, 116, 0, 0.3)',
   deepGreen: '#1d6200',
   everGreen: '#04401d',
   gameModeDarkBg: '#292d37',
   gray: '#353535',
   spanishGray: '#9E9E9E',
   greyishTwo: '#808080',
   greyish: '#aaaaaa',
   hanPurple: '#4400cc',
   greyishBrown: '#404040',
   pinkishGrey: '#d1d1d1',
   lightBlue: '#62d2f3',
   blueGrey: '#94a3b8',
   lightBlueGrey: '#dde5f6',
   lightBlueGreyTwo: '#becbed',
   lightBlueGray50: '#F8FAFC',
   lightBlueGray200: '#E2E8F0',
   lightBlueGray300: '#CBD5E1',
   lightBlueGray500: '#64748b',
   lightBlueGray600: '#475569',
   lightGrey: '#dde5f6',
   lightGreyTwo: ' #dae5f2',
   lightYellow: '#ffe200',
   lightBlack: '#2d3744',
   lightSeaBlue: '#0096ff',
   lightGrayish: '#828694',
   lightBlueGreyThree: '#d0d8e9',
   lightBlueGreyFour: '#F1F5F9',
   linerGradients,
   mango: '#ffbc2f',
   gorse: '#ffe340',
   marineBlue: '#002a77',
   darkMarineBlue: '#002166',
   marineBlueTwo: '#002967',
   marineBlueThree: '#002b54',
   martinique: '#363f4c',
   martinique80: '#363f4c80',
   mariGold: '#ffc800',
   mariner: '#3e62a8',
   myProfileTitleSilver: '#d1d4da',
   matterhorn: '#515151',
   matterhorn50: '#80515151',
   navyBlue: '#00224d',
   navyBlue2: '#1976d2',
   nobelLight: '#969696',
   nobel: '#979797',
   oceanBlue: '#016db9',
   orangeBrown: '#ba5d00',
   orangeYellow: '#ffa600',
   pageNotFoundBottomBgColor: '#cad9f0',
   pageNotFoundInfoSectionBgColor: '#f6f6f8',
   pageNotFoundPointHyperlink: '#ff6b3c',
   pageNotFoundText: '#5e6977',
   pageNotFoundTopBgColor: '#f3f4f8',
   paleBlue: '#caf8fd',
   paleGrey: '#e7e9ec',
   paleGreyTwo: '#f8fafc',
   paleGreyFour: '#fbfcfc',
   paleGreyThree: '#bec2ca',
   peacockBlue: '#004aa6',
   peacockBlue80: 'rgb(0,74,166,0.8)',
   pencilGrey: '#787878',
   pinkishOrange: '#ff6b3c',
   primaryColor: '#2196f3',
   pumpkinOrange: '#f47400',
   pumpkinOrange25: 'rgba(244,116,0,0.25)',
   brownishOrange: '#d8761e',
   pumpkinOrangeWithOpacity: 'rgb(244, 116, 0,0.3)',
   pumpkinOrangeWithOpacity70: 'rgb(244, 116, 0,0.7)',
   redBrown: '#7e1d10',
   silver: '#d1d4da',
   sonicSilver: '#71717A',
   quickSilver: '#A1A1AA',
   shamrockTwo: '#01b84d',
   skyCaptain: '#393c47',
   stormGrey: '#777A87',
   sapphire: '#0091ff',
   white: 'rgba(255,255,255,1)',
   whiteSmoke: '#f1f1f1',
   white20: 'rgba(255,255,255,0.2)',
   white30: 'rgba(255, 255, 255, 0.03)',
   white50: 'rgba(255,255,255,0.5)',
   white80: 'rgba(255,255,255,0.8)',
   whiteFour: 'rgba(255, 255, 255, 0.4)',
   whiteTwo: 'rgba(255,255,255,0.2)',
   whiteTwoWithoutGradient: '#d8d8d8',
   cultured: '#FAF7F7',
   yellowOrange: '#f7b500',
   lightRedBrown: '#932f16',
   leaderboardItemBlueColor: '#002967',
   cadetBlue: '#ADB4C2',
   prussianBlue: '#003051',
   dodgerBlue: '#008CEF',
   blackRussian2: '#1c1e24',
   slateBlue0: 'rgba(93, 106, 148, 0)',
   slateBlue40: 'rgba(93, 106, 148, 0.4)',
   greyishBrownTwo: '#37342c',
   black25: 'rgba(0, 0, 0, 0.25)',
   red: '#ff0000',
   persianRed: '#DC2626',
   greenishCyan: '#3cffc4',
   grey: '#838383',
   jungleGreen: '#007244',
   orange: '#f76b1c',
   lightMustard: '#fad961',
   tomato: '#e72a2a',
   paleSalmon: '#ffa6a6',
   dodgerBlueVariantThree: '#0087E6',
   midGreen: '#4bb747',
   adobe: '#be6644',
   flamingo: '#EA534A',
   flamingo25: 'rgba(234, 83, 74,0.25)',
   cerulean30: 'rgba(2, 98, 168, 0.3)',
   mischka: '#a3abbb',
   metallicSilver: '#A3A7B3',
   twilightBlue: '#0c2f5b',
   dodgerBlueOtp: '#3dafff',
   paleLilac45: 'rgba(229, 233, 255, 0.45)',
   darkSlateBlue: '#183b56',
   slate: '#475569',
   darkFive: '#1f2430',
   rockBlue: '#94a3b8',
   cloudyBlue: '#cbd5e1',
   slateGrey: '#5c606d',
   slateGreyTwo: '#5b6375',
   gunMetalThree: '#50545d',
   gunMetalTwo: '#2B3049',
   waterMelonColor: '#FF476F',
   treeGreen: '#42692f',
   tiffinBlue: '#73dfe7',
   brightBlue: '#0063f7',
   darkishGreen: '#388e3c',
   darkSeven: '#24252f',
   darkNine: '#29292E',
   green: '#118c0f',
   rustyOrange: '#ea580c',
   sapphireTwo: '#1e40af',
   deepAqua: '#0a6e80',
   darkGrassGreen: '#4c7808',
   brownishRed: '#952222',
   darkLavender: '#7059a4',
   neonGreen40: 'rgba(16, 255, 11, 0.4)',
   neonGreen40_0: 'rgba(16, 255, 11, 0)',
   pumpkinOrange33: 'rgba(255, 110, 34, 0.33)',
   deepSkyBlueTwo: '#0a7aff',
   deepSkyBlueThree: '#1783ee',
   darkGreyBlue: '#2f3c4e',
   darkEleven: '#212229',
   tangerine: '#ff9800',
   teal: '#009688',
   oceanBlueThree: '#005cb7',
   oceanBlueThree25: 'rgba(23, 131, 238, 0.25)',
   algaeGreen: '#22c55e',
   lightRed500: '#ef4444',
   yellow500: '#eab308',
   darkIndigoFour: '#050a15',
   booger: '#8cc63e',
   tomatoThree: '#dd4c1a',
   battleshipGreyThree: '#757678',
   darkSeaGreen: '#16a34a',
   coolGreyTwo: '#b4b7bd',
   slateGreyThree: '#595e6b',
   whiteThree: '#e2e1e1',
   clearBlue: '#257cff',
   charcoalGreySix: '#3a3b45',
   azul: '#1f70d8',
   blackFive: '#0d0d0d',
   dark80: 'rgba(19, 20, 24, 0.8)',
   charcoalGreyEight: '#404248',
   slateGreyFour: '#5a5c75',
   darkGreyBlueTwo: '#334155',
   darkGreyBlueThree: '#293444',
   darkTwelve: '#1d1e25',
   clearBlueTwo: '#1b83ff',
   outerSpace: '#46474a',
   charlestonGreen: '#25272e',
   charlestonGreenTwo: '#2b2d31',
   charlestonGreenThree: '#27272A',
   darkJungleGreen: '#181C25',
   philippineRed: '#cf1124',
   lightBlueTwo: '#5865f2',
   lightOrange500: '#F97316',
   solitude: '#E7E9EC',
   eerieBlack: '#191b1f',
   eerieBlackTwo: '#1e1e1f',
   arsenic: '#3F3F46',
   davyGrey: '#52525B',
   lightAmber600: '#D97706',
   onyx: '#37393D',
   sealBrown: '#4D2400',
   darkGunmetal: '#202633 ',
   lightTeal500: '#14B8A6',
   darkGreen: '#052C27',
   richBlackGreen: '#06413A',
   coolBlackBlue: '#08295B',
   maastrichtBlue: '#061D3F',
   purple500: '#A855F7',
   emerald500: '#10B981',
   neutral50: '#fafafa',
   neutral100: '#F4F4F5',
   neutral200: '#E4E4E7',
   neutral400: '#a1a1aa',
   neutral700: '#3f3f46',
   neutral800: '#27272A',
   neutral900: '#18181B',
   lincolnGreen: '#2C5500',
   springFrost: '#93FF2A',
   blue2: '#007BD0',
   red2: '#FF382C',
   veryLightTangelo: '#FFB47D'
}

export default colors
